import getRequest from '../../../../getRequest';

/**
 * Gets all margin thresholds.
 */
async function getMarginThresholdsSiteId(siteId) {
  const endpoint = `/oc-data-management/v1/margin-thresholds?siteId=${siteId}`;

  return new Promise((resolve, reject) => {
    getRequest(endpoint, 'Getting Margin Thresholds')
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
}

export default getMarginThresholdsSiteId;
